/**
 * Digital Disbursements Payment Widget
 *
 * @module DigitalDisbursements
 * @exports DigitalDisbursements
 * @version 3.0.0
 * @since 3.0.0
 */
import {
    appPayMethod,
    appDomain,
    i18n,
    userLanguage,
} from "commonAssets/js/constants";
import { createElement } from "commonAssets/lib/createElement.js";
import { modal } from "commonAssets/lib/modal.js";

/**
 * Creates a payment widget element for digital disbursements.
 * @param {Object} params - The parameters object.
 * @param {Object} params.form_options - The form options object.
 * @param {Object} params.form_options.claim_form - The claim form object.
 * @param {Object} params.form_options.claim_form.payment_widget - The payment widget object.
 * @param {string} params.form_options.claim_form.payment_widget.title - The title of the payment widget.
 * @param {string} params.form_options.claim_form.payment_widget.body - The body of the payment widget.
 * @returns {HTMLElement} - The payment widget element.
 */
export const DigitalDisbursements = (params) => {
    console.log("[payment_widget]");
    const paymentWidgetTitle =
        params.form_options.claim_form.payment_widget.title;
    const paymentWidgetBody =
        params.form_options.claim_form.payment_widget.body;
    const paymentWidgetHtml = createElement(
        "div",
        {
            class: "bg-light text-dark border rounded p-3 mb-5",
            id: "payment-widget",
        },
        [
            paymentWidgetTitle
                ? createElement(
                      "div",
                      { class: "h3 mb-3", id: "paymentWidgetTitle" },
                      [],
                      paymentWidgetTitle
                  )
                : ``,
            paymentWidgetBody
                ? createElement(
                      "div",
                      { class: "mb-3", id: "paymentWidgetBody" },
                      [],
                      paymentWidgetBody
                  )
                : ``,
            createElement(
                "div",
                { class: "d-none text-center", id: "update_payment_message" },
                [],
                i18n.getTranslation("payment_update_message")
            ),
            createElement("div", { id: "dst-payment", key: appPayMethod }),
            createElement(
                "script",
                {
                    type: "text/javascript",
                },
                [],
                `
          dstPaymentForm(document.getElementById('dst-payment'),
            {
              verify: false,
              ln: "${userLanguage}",
              onSubmitted: function (info) {
                document.getElementById('payment_method').value = info.method;
                document.getElementById('payment_token').value = info.token;
                if (info.paymentEmail) {
                    document.getElementById('payment_email').value = info.paymentEmail;
                }
                if (info.paymentPhone) {
                    let paymentPhone = info.paymentPhone;
                    let intlPhoneInput = document.querySelector('intl-phone-input');
                    if (intlPhoneInput) {
                        paymentPhone = intlPhoneInput.getDialCode() + paymentPhone;
                    }
                    document.getElementById('payment_phone').value = paymentPhone;
                }
              }
            }
          )
        `
            ),
            createElement("fieldset", {}, [], dstFieldset()),
        ]
    );
    return paymentWidgetHtml;
};

/**
 * Adds a title attribute to the payment widget iframe in the destination payment element.
 * @param {HTMLFormElement} form - The form element containing the payment widget.
 * @returns {void}
 * @since 3.0.0
 */
export const dstPaymentIframeTitle = (params) => {
    if (appPayMethod === "undefined" || appPayMethod === "") return;
    const dstPayment = document.getElementById("dst-payment");
    const iframe = dstPayment.querySelector("iframe");
    const iframeTitle = params.form_options.claim_form.payment_widget.title;
    iframe.setAttribute("title", iframeTitle);
};

/**
 * Populates the DST payment form with data.
 *
 * This assumes the following:
 *  - then, if the payment method is not set, it will return.
 *
 * @param {Object} data - The data to populate the form with.
 */
export const dstMember = () => {
    console.log("[payment_widget_member]");
    if (!document.getElementById("payment_method").value) return;
    document.getElementById("dst-payment").classList.add("d-none");
    document.getElementById("previous_payment_method").innerText =
        document.getElementById("payment_method").value;
    document
        .getElementById("update_payment_toggle")
        .addEventListener("click", function () {
            document
                .getElementById("update_payment_message")
                .classList.add("d-none");
            document.getElementById("dst-payment").classList.remove("d-none");
        });
    document
        .getElementById("update_payment_message")
        .classList.remove("d-none");
};

/**
 * dstFieldset()
 * Returns the DST fieldset HTML.
 * @returns {string} The DST fieldset HTML.
 */
export const dstFieldset = () => {
    console.log("[payment_widget_fieldset]");
    const fieldset = `
    <input type="hidden" name="payment_method" id="payment_method" value="" data-label="Payment Method" />
    <input type="hidden" name="payment_token" id="payment_token" value="" data-label="Payment Token" />
    <input type="hidden" name="payment_email" id="payment_email" value="" data-label="Payment Email" />
    <input type="hidden" name="payment_phone" id="payment_phone" value="" data-label="Payment Phone" />
    `;
    return fieldset;
};

/**
 * dstProcess()
 * Processes the DST (Digital Disbursements) for a claim.
 * @param {object} claim - The claim object to be processed.
 * @returns {object} - The processed claim object.
 */
export const dstProcess = (claim) => {
    console.log("[payment_widget_process]");
    if (
        !document.getElementById("payment_method") ||
        !document.getElementById("payment_token") ||
        !document.getElementById("payment_method").value ||
        !document.getElementById("payment_token").value
    ) {
        claim.flags.valid = false;
        modal(
            i18n.getTranslation("error"),
            i18n.getTranslation("payment_select_error")
        );
        return claim;
    }
    if (
        document.getElementById("email_address").value &&
        document.getElementById("payment_email").value &&
        document.getElementById("email_address").value.toLowerCase() !=
            document.getElementById("payment_email").value.toLowerCase()
    ) {
        claim.flags.valid = false;
        modal(
            i18n.getTranslation("error"),
            i18n.getTranslation("claim_processing_email_error")
        );
        return claim;
    }
    if (
        document.getElementById("phone_number_1").value &&
        document.getElementById("payment_phone").value &&
        document.getElementById("phone_number_1").value.replace(/\D/g, "") !=
            document.getElementById("payment_phone").value.replace(/\D/g, "")
    ) {
        claim.flags.valid = false;
        modal(
            i18n.getTranslation("error"),
            i18n.getTranslation("claim_processing_phone_error")
        );
        return claim;
    }
    return claim;
};
